import { ConfigService, ErrorsService, ModelsList, StoreService } from 'shared';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseModel } from 'projects/shared/src/lib/models/base.model';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})

export class CampaignService extends StoreService<Campaign> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Campaign);
  }

  load(queryParams?: HttpParams): Observable<ModelsList<Campaign>> {
    return this.http.get<ModelsList<Campaign>>(this.config.apiVerUrl('/app/campaigns'), { params: queryParams })
  }

  insert(values: Campaign): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/campaigns'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/campaigns/${id}`));
  }

  update(id, values: Campaign): Observable<Campaign> {
    return this.http.put<Campaign>(this.config.apiVerUrl(`/app/campaigns${id}`), values);
  }

}

export interface ICampaign {
  "id": number;
  "name": string;
  "start_date": Date;
  "end_date": Date;
  "is_current": boolean;
  "is_selected": boolean;
}

export class Campaign extends BaseModel<ICampaign> {
  id: number;
  name: string;
  start_date: Date;
  end_date: Date;
  is_current: boolean;
  is_selected: boolean;
}
